import { render, staticRenderFns } from "./Notifications2.vue?vue&type=template&id=2fa15158&scoped=true&"
import script from "./Notifications2.vue?vue&type=script&lang=js&"
export * from "./Notifications2.vue?vue&type=script&lang=js&"
import style0 from "./Notifications2.vue?vue&type=style&index=0&id=2fa15158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa15158",
  null
  
)

export default component.exports